














































































import Vue from 'vue'
import { mapState } from 'vuex'
import * as db from '@/plugins/db'

export default Vue.extend({
  data () {
    return {
      loading: false,
      dialog: false,
      tableHeaders: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Chinese Name',
          value: 'nameChinese'
        },
        {
          text: 'Gender',
          value: 'gender'
        },
        {
          text: 'Hall #',
          value: 'hall'
        },
        {
          text: 'Phone number',
          value: 'phone'
        },
        {
          text: 'Year of birth',
          value: 'yob'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        nameChinse: '',
        gender: '',
        hall: '',
        phone: '',
        yob: ''
      },
      defaultItem: {
        name: '',
        nameChinse: '',
        gender: '',
        hall: '',
        phone: '',
        yob: ''
      }
    }
  },
  created () {
    this.$store.dispatch('getNameList')
  },
  computed: {
    ...mapState([
      'nameList',
      'nameListLoading'
    ])
  },
  methods: {

    editItem (item: any) {
      this.editedIndex = item.id
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item: any) {
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.dispatch('deleteName', item.id)
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      this.close()
      this.$store.dispatch('editNameList', {
        id: this.editedIndex,
        item: this.editedItem
      })
    }
  }
})
